// extracted by mini-css-extract-plugin
export default {"textarea":"Nv168u","noresize":"q6qMgS"};